<script>
import Button from '@/components/Button'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueUtils from '@/utils/vueUtils'
import DialogUtils from '@/utils/dialogUtils'
import ArrayUtils from '@/utils/arrayUtils'

export default
{
    name: 'card-list-edit-tags',

    props:
    {
        tags: { type: Array, required: true },
        cards: { type: Array, required: true },
        cardObjectName: { type: String, required: true }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div id='card-list-edit-tags-view'>
                <div id='content'>
                    <div class='title'>Editer les libellés</div>
                    <div class='card'>
                        <Button class='create-new-tag' text='Ajouter un nouveau libellé' type='light' icon={require('@/assets/img/plus.svg')}
                            on-click={(e, b) => this.createTag(b)} />
                        {
                            this.modifiedTags.map(tag =>
                            {
                                const originalName = (this.tags.find(t => t.id == tag.id) || {}).name
                                const hasTagNameChanged = tag.name != originalName

                                return <div class='tag-edition-section'>
                                    <floating-label-text-input v-model={tag.name} disabled={!tag.isEditable} />
                                    <Button v-show={hasTagNameChanged} type='primary' icon={require('@/assets/img/check.svg')}
                                        on-click={(e, b) => this.renameTag(b, tag.id, tag.name)} />
                                    <Button v-show={!hasTagNameChanged} disabled={!tag.isEditable} type='light' icon={require('@/assets/img/cross.svg')}
                                        on-click={(e, b) => this.deleteTag(b, tag.id)} />
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            modifiedTags: []
        }
    },

    computed:
    {
    },

    watch:
    {
        tags ()
        {
            this.modifiedTags = VueUtils.getObserverless(this.tags)
        }
    },

    mounted ()
    {
    },

    methods:
    {
        renameTag (button, tagId, name)
        {
            this.modifiedTags.find(t => t.id == tagId).name = name

            button.showSpinnerWhile(async () =>
            {
                await this.saveTags(this.modifiedTags)
            })
            
        },

        async deleteTag (button, tagId)
        {
            const taggedCard = this.cards.filter(r => r.tags.includes(tagId))
            const taggedCardWithNoOtherTags = taggedCard.filter(r => r.tags.length == 1)
            
            const len = taggedCardWithNoOtherTags.length
            if (len > 0)
            {
                const s = len > 1 ? 's' : ''
                const description = `Vous avez ${len} ${this.cardObjectName}${s} libellé${s} avec ce label uniquement. Il${s} ser${s ? 'ont' : 'a'} automatiquement`
                    + ` libellé${s} comme ${this.tags[0].name}. Voulez-vous continuer ?`
                const confirm = await DialogUtils.waitForUserConfirmationAsync({description})
                
                if (!confirm) return
                for (let card of taggedCardWithNoOtherTags)
                {
                    this.cards.find(c => c.id == card.id).tags.push(this.tags[0].id)
                }
            }

            for (let card of taggedCard)
            {
                ArrayUtils.removeByValue(this.cards.find(c => c.id == card.id).tags, tagId)
            }

            button.showSpinnerWhile(async () =>
            {
                if (taggedCard.length > 0) await this.saveCards(taggedCard)

                const tagsToSave = VueUtils.getObserverless(this.tags)
                tagsToSave.splice(tagsToSave.findIndex(t => t.id == tagId), 1)

                await this.saveTags(tagsToSave)
            })
        },

        createTag (button)
        {
            const higherTagsId = this.tags.map(t => Number.parseInt(t.id)).sort((a, b) => a - b).pop() || 0
            const newTag = {id: (higherTagsId + 1).toString(), name: 'Nouveau libellé', isEditable: true, icon: { name: 'tag' }}
            this.modifiedTags.push(newTag)
            
            button.showSpinnerWhile(async () =>
            {
                await this.saveTags(this.modifiedTags)
            })
        },

        async saveTags (tags)
        {
            this.$emit('tags-modified', tags)
        },

        async saveCards (cards)
        {
            this.$emit('cards-tags-changed', cards)
        }
    },

    components:
    {
        FloatingLabelTextInput,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#card-list-edit-tags-view
{
    > #content
    {
        > .title
        {
            font-size: 19px;
            font-weight: 600;
            margin-left: 7px;
            margin-top: 40px;
            margin-bottom: 10px;
        }

        > .card
        {
            background-color: var(--theme-content-background-color);
            width: -webkit-fill-available;
            padding: 14px 10px;
            border-radius: 5px;

            .tag-edition-section
            {
                display: flex;
                flex-direction: row;
                margin-top: 10px;

                .floating-label-text-input
                {
                    width: 100%;
                    height: 40px;

                    &:not(.disabled)
                    {
                        border-color: var(--theme-border-color-light);
                    }
                }

                .button
                {
                    margin-left: 5px;
                    .WidthHeight(42px);
                }
            }

            .button.create-new-tag
            {
                width: 100%;
                padding: 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CardListEditTags.vue